module.exports = __webpack_public_path__ + "img/dd1860e.png";